// import React from "react";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import { useDispatch, useSelector } from "react-redux";

// import esearchlogo1 from "../assets/images/esearchlogo1.png";
// import { useNavigate } from "react-router-dom";
// import { logOut } from "../redux-store/slices/authSlice";

// const Header = () => {
//   const { userDetails } = useSelector((state) => state.auth);
//   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

//   const distpatch = useDispatch();
//   const navigate = useNavigate();
//   const handleLogout = () => {
//     distpatch(logOut());
//     navigate("/");
//   };
//   return (
//     <div className="bg-white w-full">
//       {/* Main container */}
//       <div className="flex flex-col md:flex-row justify-between items-center p-2 md:p-4">
//         {/* Logo & Title Section */}
//         <div className="flex items-center space-x-3 w-full md:w-auto">
//           <img
//             src={esearchlogo1}
//             alt="logo"
//             className="w-10 h-auto md:w-14 md:h-14"
//           />
//           <div className="text-center md:text-left">
//             <h1 className="text-sm font-serif md:text-lg">
//               STAMPS & REGISTRATION DEPARTMENT
//             </h1>
//             <h3 className="text-xs italic font-semibold md:text-sm">
//               Government Of Uttarakhand
//             </h3>
//           </div>
//         </div>

//         {userDetails?.userRole === "SuperAdmin" && isLoggedIn && (
//           <div className="flex items-center justify-between w-full md:w-auto mt-2 md:mt-0 space-x-4">
//             {/* HOD Login & Logout */}
//             <div className="flex items-center space-x-3">
//               <div className="text-center md:text-left">
//                 <div className="text-gray-700 italic font-semibold gap-2">
//                   {userDetails?.userDesig} :{userDetails?.username}
//                 </div>
//                 <button
//                   onClick={() => {
//                     handleLogout();
//                   }}
//                   className="text-[#FF2222] font-semibold italic flex items-center space-x-1 hover:underline"
//                 >
//                   <span>Logout Account</span>
//                   <PowerSettingsNewIcon fontSize="small" />
//                 </button>
//               </div>
//               {/* Divider */}
//               <div className="hidden md:block border-l border-gray-300 h-6"></div>
//             </div>

//             {/* Notification Bell */}
//             <div className="relative">
//               <div
//                 onClick={() => navigate("/PowerRegularizationAIGAction")} // ✅
//                 className="bg-white shadow-lg p-2 rounded-md"
//               >
//                 <NotificationsIcon
//                   className="text-[#4F9CF9]"
//                   fontSize="medium"
//                 />
//               </div>
//               <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full px-1">
//                 1
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Header;

// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import MenuIcon from "@mui/icons-material/Menu";
// import { logOut } from "../redux-store/slices/authSlice";
// import esearchlogo1 from "../assets/images/esearchlogo1.png";

// const Header = ({ onMenuToggle }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { userDetails, isLoggedIn } = useSelector((state) => state.auth);

//   const handleLogout = () => {
//     dispatch(logOut());
//     navigate("/");
//   };

//   return (
//     <div className="bg-white w-full shadow-sm">
//       <div className="flex flex-col md:flex-row justify-between items-center p-2 md:p-4">
//         {/* Hamburger on mobile */}
//         <button
//           onClick={onMenuToggle}
//           className="md:hidden p-2 rounded hover:bg-gray-100"
//         >
//           <MenuIcon fontSize="large" />
//         </button>

//         {/* Logo & Title */}
//         <div className="flex items-center space-x-3 w-full md:w-auto">
//           <img
//             src={esearchlogo1}
//             alt="logo"
//             className="w-8 h-8 md:w-14 md:h-14"
//           />
//           <div className="text-center md:text-left">
//             <h1 className="text-xs md:text-lg font-serif">
//               STAMPS & REGISTRATION DEPARTMENT
//             </h1>
//             <h3 className="text-[10px] md:text-sm italic font-semibold">
//               Government Of Uttarakhand
//             </h3>
//           </div>
//         </div>

//         {/* SuperAdmin info & notifications */}
//         {isLoggedIn && userDetails?.userRole === "SuperAdmin" && (
//           <div className="flex flex-col sm:flex-row items-center w-full md:w-auto mt-4 sm:mt-0 sm:space-x-4 space-y-2 sm:space-y-0">
//             <div className="flex items-center space-x-2">
//               <div className="text-gray-700 italic font-semibold text-sm">
//                 <span className="hidden sm:inline">
//                   {userDetails.userDesig} : {userDetails.username}
//                 </span>
//               </div>
//               <button
//                 onClick={handleLogout}
//                 className="text-[#FF2222] italic flex items-center space-x-1 hover:underline"
//               >
//                 <PowerSettingsNewIcon fontSize="small" />
//                 <span className="hidden sm:inline">Logout</span>
//               </button>
//             </div>

//             <div className="relative">
//               <button
//                 onClick={() => navigate("/PowerRegularizationAIGAction")}
//                 className="bg-white shadow p-2 rounded-md hover:shadow-md"
//               >
//                 <NotificationsIcon fontSize="medium" />
//               </button>
//               <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full px-1">
//                 1
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };
// export default Header;

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NotificationsIcon from "@mui/icons-material/Notifications";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import MenuIcon from "@mui/icons-material/Menu";

import { logOut } from "../redux-store/slices/authSlice";
import esearchlogo1 from "../assets/images/esearchlogo1.png";

const Header = ({ onMenuToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails, isLoggedIn } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logOut());
    navigate("/");
  };

  return (
    <header className="bg-white w-full shadow-sm">
      <div className="flex items-center justify-between p-2 md:p-4">
        {/* Hamburger (mobile only) */}
        <button
          onClick={onMenuToggle}
          className="md:hidden p-2 rounded hover:bg-gray-100"
        >
          <MenuIcon fontSize="large" />
        </button>

        {/* Logo & Title */}
        <div className="flex items-center space-x-3">
          <img
            src={esearchlogo1}
            alt="logo"
            className="w-8 h-8 md:w-14 md:h-14"
          />
          <div className="text-center md:text-left">
            <h1 className="text-xs md:text-lg font-serif">
              STAMPS & REGISTRATION DEPARTMENT
            </h1>
            <h3 className="text-[10px] md:text-sm italic font-semibold">
              Government Of Uttarakhand
            </h3>
          </div>
        </div>

        {/* SuperAdmin info & Notifications */}
        {isLoggedIn && userDetails?.userRole === "SuperAdmin" && (
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <span className="hidden sm:inline text-gray-700 italic font-semibold text-sm">
                {userDetails.userDesig} : {userDetails.username}
              </span>
              <button
                onClick={handleLogout}
                className="text-[#FF2222] italic flex items-center space-x-1 hover:underline"
              >
                <PowerSettingsNewIcon fontSize="small" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>

            <button
              onClick={() => navigate("/PowerRegularizationAIGAction")}
              className="relative bg-white shadow p-2 rounded-md hover:shadow-md"
            >
              <NotificationsIcon fontSize="medium" />
              <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full px-1">
                1
              </span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
export default Header;
